import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
declare const $: any;

@Component({
  selector: 'app-modal-audio-report',
  templateUrl: './modal-audio-report.component.html',
  styleUrls: ['./modal-audio-report.component.scss']
})
export class ModalAudioReportComponent implements OnInit {

  @ViewChild('modal', { static: false }) modal: ElementRef;
  @ViewChild('peity', { static: false }) peity: ElementRef;
  detailFile: any;

  constructor() { }

  ngOnInit(): void {
  }

  show(detailFile: any): void {
    // Calculamos promedio de confianza
    const confidence = detailFile.conversacion.map( c => +c.alternatives[0].confidence );
    const sumConfidence = confidence.reduce( (a, b) => a + b, 0);
    const avgConfidence = (sumConfidence / confidence.length) || 0 ;

    detailFile.confidence =  avgConfidence * 100;


    // Información de gráfica
    const peity: any = this.peityData(detailFile);
    detailFile.peity = peity.data;
    detailFile.peityPercentage = peity.percentage;
    detailFile.percentageFormat = peity.percentageFormat;

    // Parser de transcripción de audio
    detailFile.parser = this.parserTranscribe(detailFile.conversacion, detailFile.conversacion_info);

    // Análisis
    const keys = Object.keys(detailFile.analize_text.data);
    detailFile.analyze = keys.map( k => detailFile.analize_text.data[k]);

    // Sentimientos
    const sentiments = Object.keys(detailFile.sentiment.SentimentScore)
      .map(s => ({ key: s, value: detailFile.sentiment.SentimentScore[s] }))
      .sort((a, b) => b.value - a.value);

    detailFile.sentiments = sentiments;

    this.detailFile = {...detailFile};

    setTimeout( () => $(this.peity.nativeElement).peity('donut') );
    setTimeout( () => this.initTooltip() );

    $(this.modal.nativeElement).modal('show');

    $(this.modal.nativeElement).on('hidden.bs.modal',  (e) => {
      this.detailFile = null;
    });
  }

  initTooltip(): void {
    $('[data-toggle="tooltip"]').tooltip();
  }

  parserTranscribe(items: Array<any>, speakerLabels: any): Array<any> {
    const segments = speakerLabels.segments;
    const segmentsItems = [].concat(...segments.map( s => s.items));

    const conversation = [];
    const words = [];
    let currentSpeaker: string;

    items.forEach( item => {
      if (item.start_time && item.end_time) {
        const row = segmentsItems.find(segmentItem => segmentItem.start_time === item.start_time && segmentItem.end_time === item.end_time);
        currentSpeaker = row.speaker_label;
      }

      words.push({
        content: item.alternatives[0].content,
        confidence: item.alternatives[0].confidence,
        type: item.type,
        speaker_label: currentSpeaker
      });
    });

    let content = [];
    currentSpeaker = words[0].speaker_label;
    words.forEach( word => {

      if (currentSpeaker === word.speaker_label) {
        content.push(word);
      } else {
        conversation.push({
          speaker_label: currentSpeaker,
          content
        });

        content = [word];
        currentSpeaker = word.speaker_label;
      }
    });

    conversation.push({
      speaker_label: currentSpeaker,
      content
    });

    return conversation;
  }

  peityData(file): any {
    if (!file.sentiment) {
      return {
        data: '',
        percentage: '',
        percentageFormat: ''
      };
    }

    const data = {
      fill: [],
      height: 35 * 2,
      width: 35 * 2,
      innerRadius: 13 * 2
    };

    const score = file.sentiment.SentimentScore;
    const sentiments = Object.keys(score)
      .map(s => ({ key: s, value: score[s] }))
      .sort((a, b) => b.value - a.value);

    const first = sentiments[0];

    const scoreCedula = file.score;
    const scoreCedulaTotal = file.score_total;

    const percentage = Math.round((scoreCedula * 100) /  scoreCedulaTotal);

    if (percentage >= 0 && percentage <= 30 ) {
      data.fill = ['#FF3B05', '#e5e9f2'];
    } else if (percentage > 30 && percentage <= 40 ) {
      data.fill = ['#FFC107', '#e5e9f2'];
    } else if (percentage > 40 && percentage <= 70 ) {
      data.fill = ['#FFF508', '#e5e9f2'];
    } else {
      data.fill = ['#10b759', '#e5e9f2'];
    }

    // switch (first.key.toUpperCase()) {
    //   case 'NEUTRAL':
    //     data.fill = ['#7987a1', '#e5e9f2'];
    //     break;
    //   case 'NEGATIVE':
    //     data.fill = ['#dc3545', '#e5e9f2'];
    //     break;
    //   case 'POSITIVE':
    //     data.fill = ['#10b759', '#e5e9f2'];
    //     break;
    //   case 'MIXED':
    //     data.fill = ['#ffc107', '#e5e9f2'];
    //     break;
    //   default:
    //     return '';
    // }

    return {
      data: JSON.stringify(data),
      percentage: `${percentage},${100 - percentage}`,
      percentageFormat: `${percentage}%`
    };
  }

  convertSpeakerLabel(spk: string): string {
    const PERSONS = ['A', 'B'];

    const chunks = spk.split('_');

    return `Persona ${PERSONS[chunks[1]]}`;
  }

  confidenceFormat(confidence: number): number {
    const percentage = confidence * 100;

    return Math.round((percentage + Number.EPSILON) * 100) / 100;
  }

  getClassSentiment(type: string): string {
    switch (type.toUpperCase()) {
      case 'NEUTRAL':
        return 'sentiment-neutral';
      case 'NEGATIVE':
        return 'sentiment-negative';
      case 'POSITIVE':
        return 'sentiment-positive';
      case 'MIXED':
        return 'sentiment-mixed';
      default:
        return '';
    }
  }

}
